import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useState } from "react";
import { InvoiceTracking } from "./Table";
import { Fetch } from "../../shared/Fetch";
import { format } from "date-fns";
import { Dialog } from "primereact/dialog";
import { ILogin } from "../../models/Login";
import { safeFormatDate } from "../../models/DateFormatMapper";

interface IProps {
    open: boolean,
    singleData: InvoiceTracking,
    onHide: () => void,
    toast: any
}

export const History = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: any[], loading: boolean });

    const loadTabelData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("InvoiceTracking/getPVinvoiceHistory", "GET", null, `InvoiceID=${props.singleData.invoice_ID}`, props.toast);
        if (response) {
            const data: any[] = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: true });
    }

    const onClose = () => {
        setTableData({ tableData: [], loading: false });
        props.onHide();
    }

    useEffect(() => {
        if (props.open && props.singleData.invoice_ID) {
            loadTabelData();
        }
    }, [props.open]);

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFromat = loginObj.date_Format;
    return (
        <>
            <Dialog visible={props.open} style={{ width: '80vw' }} header={<p>PV Invoice History</p>} className="p-fluid" onHide={onClose} draggable={false}>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                    value={tableData.tableData}
                    loading={tableData.loading}
                    dataKey="invoice_History_ID"
                    paginator
                    rows={100}
                    rowsPerPageOptions={[5, 10, 20, 50, 100]}
                >
                    <Column header="SN." body={(rowData, options) => options.rowIndex + 1} />
                    <Column field="invoiceNO" header="#Invoice" />
                    {/* <Column field="fromDate" header="From Date" body={(rowData: InvoiceTracking) => {
                        let date;
                        if (rowData.fromDate) date = format(new Date(rowData.fromDate), 'dd/MM/yyyy').toUpperCase();
                        else date = "";
                        return (<>{date}</>);
                    }} /> */}
                    <Column field="fromDate" header="From Date" body={(rowData: any) => safeFormatDate(rowData.fromDate, 'dd/MM/yyyy', DateFromat)} />
                    {/* <Column field="toDate" header="To Date" body={(rowData: InvoiceTracking) => {
                        let date;
                        if (rowData.toDate) date = format(new Date(rowData.toDate), 'dd/MM/yyyy').toUpperCase();
                        else date = "";
                        return (<>{date}</>);
                    }} /> */}
                    <Column field="toDate" header="To Date" body={(rowData: any) => safeFormatDate(rowData.toDate, 'dd/MM/yyyy', DateFromat)} />
                    <Column field="invoiceHours" header="Hrs" />
                    <Column field="invoiceAmount" header="Invoice Amount ($)" />
                    {/* <Column field="invoiceDate" header="Invoice Date" body={(rowData: InvoiceTracking) => {
                        let date;
                        if (rowData.invoiceDate) date = format(new Date(rowData.invoiceDate), 'dd/MM/yyyy').toUpperCase();
                        else date = "";
                        return (<>{date}</>);
                    }} /> */}
                    <Column field="invoiceDate" header="Invoice Date" body={(rowData: any) => safeFormatDate(rowData.invoiceDate, 'dd/MM/yyyy', DateFromat)} />
                    {/* <Column field="dueDate" header="Due Date" body={(rowData: InvoiceTracking) => {
                        let date;
                        if (rowData.invoiceDate) date = format(new Date(rowData.invoiceDate), 'dd/MM/yyyy').toUpperCase();
                        else date = "";
                        return (<>{date}</>);
                    }} /> */}
                    <Column field="dueDate" header="Due Date" body={(rowData: any) => safeFormatDate(rowData.dueDate, 'dd/MM/yyyy', DateFromat)} />
                    <Column field="verfiedBy" header="Verfied By" />
                    <Column field="verifyComment" header="Verify Comment" />
                    <Column field="invoiceStatus" header="Invoice Status" />
                    <Column field="paymentStatus" header="Payment Status" />
                    <Column field="invoice_Cycle" header="Invoice Cycle" />
                    <Column field="payment_Term" header="Payment Term" />
                    <Column field="payment_Mode" header="Payment Mode" />
                    <Column field="receivedAmount" header="Received Amount ($)" />
                    {/* <Column field="payment_Date" header="Payment Date" body={(rowData: InvoiceTracking) => {
                        let date;
                        if (rowData.payment_Date) date = format(new Date(rowData.payment_Date), 'dd/MM/yyyy').toUpperCase();
                        else date = "";
                        return (<>{date}</>);
                    }} /> */}
                    <Column field="payment_Date" header="Payment Date" body={(rowData: any) => safeFormatDate(rowData.payment_Date, 'dd/MM/yyyy', DateFromat)} />
                    <Column field="transaction_ID" header="Transaction ID" />
                    <Column field="is_Credit_Note" header="Credit Note" body={(rowData) => <p>{rowData.is_Credit_Note === true ? "Yes" : "No"}</p>} />
                    <Column field="credit_Note_Comment" header="Credit Note Comment" />
                    <Column field="is_Verified" header="Verified" body={(rowData) => <p>{rowData.is_Verified === true ? "Yes" : "No"}</p>} />
                    <Column field="isCalculated" header="Hold" body={(rowData) => <p>{rowData.isCalculated === true ? "Yes" : "No"}</p>} />
                    <Column field="dollerRate" header="Doller Rate" />
                    {/* <Column field="updatedOn" header="Updated On" body={(rowData: any) => {
                        let date;
                        if (rowData.updatedOn) date = format(new Date(rowData.updatedOn), 'dd/MM/yyyy').toUpperCase();
                        else date = "";
                        return (<>{date}</>);
                    }} /> */}
                     <Column field="updatedOn" header="Updated On" body={(rowData: any) => safeFormatDate(rowData.updatedOn, 'dd/MM/yyyy', DateFromat) }/>
                    <Column field="updatedBy" header="Updated By" />
                </DataTable>
            </Dialog>
        </>
    );
}